import React, { useState } from "react";
import AuthButton from "../AuthButton/AuthButton";
import { useSelector } from "react-redux";
import StripeContainer from "../../Stripe/Stripe";
import PaymentForm from "../../Stripe/StripeForm";
import { useNavigate } from "react-router-dom";
import {
  ACTIVETAB,
  POST_LOGIN,
  afterPayment,
  cancelSubscription,
  getClientbyid,
  updateClient,
} from "../../Actions/actions";
import { useDispatch } from "react-redux";
import { BiStar } from "react-icons/bi";
import { BsStarFill } from "react-icons/bs";
import Loader from "../Loader/Loader";

const PlanSubscription = () => {
  const { loginData, role, taskData, singleClient, loader, Privilages } = useSelector((state) => state.userReducer);
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedPlan, setSelectedPlan] = useState(loginData?.clientData?.subscriptionType || "Free Forever");
  const [billingCycle, setBillingCycle] = useState("monthly");
  const plans = [
    {
      name: "Free Forever",
      monthly: "Free",
      yearly: "Free",
      bgColor: "bg-gradient-to-b from-[#B3FFE7] to-[#EDEDED]",
      textColor: "#4C3736",
      isCurrent: true,
      amount: 4.99 * 100,
      includes: [
        "Up to 3 seats",
        "Up to 2 custom roles",
        "Up to 3 accounts creation",
        "Manage up to 20 leads",
        "Up to 1 visit per lead",
        "100 minutes of in-app calling",
        "Schedule up to 15 meetings",
        "5 meetings history",
        "50 push notifications monthly",
        "7 days activity logs & reports",
        "5 visit travel history records",
        "Manage up to 5 assets",
        "Assign up to 10 urgent activities",
        "Set up to 20 call back reminders",
        "Basic support via email",
      ],
    },
    {
      name: "Repotal Pro",
      monthly: 14.99,
      yearly: 179.88,
      textColor: "#6C6B6D",
      isCurrent: false,
      bgColor: "bg-gradient-to-b from-[#B3EBFF] to-[#EDEDED]",
      amount: 14.99 * 100,
      priceidMonthly: "price_1RR9wPPs9SlHAQ3iL8n3zvKi",
      priceidYearly: "price_1RR9z5Ps9SlHAQ3i3LNk8RWx",
      productMonthly: "prod_SLrfWx6NRyj60a",
      productYearly: "prod_SLriOO8oCsryfD",
      includes: [
        "Up to 4–15 seats",
        "Up to 5 custom roles",
        "Up to 20 accounts creation",
        "Manage up to 200 leads",
        "Up to 10 visits per lead",
        "1,000 minutes of in-app calling",
        "Schedule up to 300 meetings",
        "100 meetings history",
        "500 push notifications monthly",
        "3 months activity logs & reports",
        "100 visit travel history records",
        "Manage up to 100 assets",
        "Assign up to 100 urgent activities",
        "Set up to 300 call back reminders",
        "Priority support via email & chat",
        "Basic real-time dashboard",
        "Bulk data import/export",
      ],
    },
    {
      name: "Repotal Ultimate",
      monthly: 30.99,
      yearly: 371.88,
      textColor: "#A89046",
      isCurrent: false,
      bgColor: "bg-gradient-to-b from-[#FFB3B3] to-[#EDEDED]",
      amount: 30.99 * 100,
      priceidMonthly: "price_1RR9xxPs9SlHAQ3i13R4RBmg",
      priceidYearly: "price_1RRA00Ps9SlHAQ3iAkGYBR8H",
      productMonthly: "prod_SLrhz2SYJtfZAI",
      productYearly: "prod_SLrj77yOdVhBYM",
      includes: [
        "15+ seats (Scalable)",
        "Unlimited custom roles",
        "Unlimited accounts creation",
        "Unlimited leads management",
        "Unlimited visits per lead",
        "Unlimited minutes of in-app calling",
        "Unlimited meetings scheduling",
        "Maximum meetings history (no cap)",
        "Unlimited push notifications",
        "Full activity logs & reports history",
        "Unlimited visit travel history records",
        "Unlimited assets management",
        "Unlimited urgent activities assigning",
        "Unlimited call back reminders",
        "Dedicated Account Manager",
        "Advanced real-time dashboard",
        "Custom reporting & analytics",
        "24/7 priority support",
      ],
    },
  ];

  return (
    <div className="bg-white p-6 rounded-xl shadow-lg max-w-3xl mx-auto">
      <div className="flex justify-between">
        <h2 className=" text-lg font-medium mb-6">Plans</h2>
        <div className="flex justify-center mb-6">
          <button
            onClick={() => setBillingCycle("monthly")}
            className={`px-4 py-2 rounded-l-lg text-sm ${
              billingCycle === "monthly" ? "bg-primary text-white" : "bg-gray-200 text-gray-700"
            }`}
          >
            Monthly
          </button>
          <button
            onClick={() => setBillingCycle("yearly")}
            className={`px-4 py-1 rounded-r-lg text-sm ${
              billingCycle === "yearly" ? "bg-primary text-white" : "bg-gray-200 text-gray-700"
            }`}
          >
            Yearly
          </button>
        </div>
      </div>
      <div className="flex space-x-3 mb-8 py-2">
        {plans.map((plan, index) => (
          <div
            key={index}
            onClick={() => setSelectedPlan(plan.name)}
            className={`w-1/3 border rounded-lg text-center cursor-pointer relative 
              ${plan.bgColor}
        ${selectedPlan === plan.name ? "border-[rgb(54,29,50)] shadow-lg" : "border-gray-200"}`}
          >
            <h3 className={`text-lg font-semibold mt-7 text-[${plan.textColor}]`}>{plan.name}</h3>
            <p className={`text-sm font-bold text-[${plan.textColor}] mb-2 text-center opacity-90`}>
              {plan.name !== "Free Forever" && "AED"}
              {billingCycle === "monthly" ? plan.monthly : plan.yearly}/{billingCycle === "monthly" ? "mo" : "yr"}
            </p>

            <ul className="list-disc list-inside text-left my-4 px-2 space-y-1">
              {plan.includes.map((feature, idx) => (
                <li key={idx} className="text-sm text-left">
                  {/* <span className="size-1.5 bg-black mr-3 rounded-md" /> */}
                  {/* <span>
                    </span> */}
                  {feature}
                </li>
              ))}
            </ul>

            {selectedPlan === plan.name && (
              <div className="absolute top-0 right-2 bg-gray-100 text-xs px-2 py-1 rounded flex items-center space-x-1 text-gray-800">
                <BsStarFill color="#B78643" />
                <span className="text-[#B78643]">Selected</span>
              </div>
            )}

            {/* <div className={`h-32 rounded-lg ${plan.bgColor}`}></div> */}
          </div>
        ))}
      </div>

      {/* <div className="border-t border-gray-200 pt-4 text-sm space-y-4">
        {billingDetails.map((detail, index) => (
          <div key={index} className="flex">
            <span className="text-sm text-gray-500 w-2/4">{detail.label}</span>
            <span className="text-sm font-medium text-gray-800 w-2/4">{detail.value}</span>
          </div>
        ))}
      </div> */}

      {/* <div className="flex justify-end mt-6 space-x-4">
       
            <AuthButton
              className="bg-white px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
              width={'20%'} title={'Cancel Plan'}
              onClick={() => {
                let price = loginData?.clientData?.subscriptionType == 'Free Forever' ? 4.99 : loginData?.clientData?.subscriptionType == "Repotal Pro" ? 14.99 : 30.99
                navigate('/subscription-requests/payment', {
                  state: { amount: price },
                })
              }}

            />

            <AuthButton width={'20%'} title={'Upgrade Plan'} className="px-4 py-2  text-white rounded-md" />
          
      </div> */}
      {loader ? (
        <div className="flex justify-end mt-6 space-x-4">
          <Loader />
        </div>
      ) : (
        <div className="flex justify-end mt-6 space-x-4">
          {loginData?.clientData?.subscriptionType == "Free Forever" && selectedPlan == "Free Forever" ? null : (
            <AuthButton
              className={`px-4 py-2 text-white rounded-md ${
                selectedPlan === loginData?.clientData?.subscriptionType &&
                selectedPlan !== "Free Forever" &&
                "bg-red-800"
              }`}
              width={"20%"}
              title={
                selectedPlan === "Free Forever"
                  ? "Get Started"
                  : selectedPlan === loginData?.clientData?.subscriptionType
                  ? "Cancel Subscription"
                  : "Pay Now"
              }
              onClick={() => {
                if (selectedPlan === "Free Forever") {
                  dispatch(
                    updateClient(
                      singleClient?.id,
                      {
                        subscriptionType: "Free Forever",
                        paymentStatus: "paid",
                      },
                      loginData?.accessToken,
                      () => {
                        dispatch(
                          getClientbyid(
                            loginData?.accessToken,
                            loginData?.clientData?.id,
                            (result) => {
                              dispatch({
                                type: POST_LOGIN,
                                payload: {
                                  ...loginData,
                                  clientData: result.client,
                                },
                                role: role,
                                Privilages: Privilages,
                              });
                              navigate("/dashboard");
                              dispatch({
                                type: ACTIVETAB,
                                payload: "Dashboard",
                              });
                            },
                            () => {}
                          )
                        );
                      }
                    )
                  );
                } else if (selectedPlan === loginData?.clientData?.subscriptionType) {
                  dispatch(
                    cancelSubscription(loginData?.accessToken, singleClient?.id, () => {
                      dispatch(
                        getClientbyid(
                          loginData?.accessToken,
                          loginData?.clientData?.id,
                          (result) => {
                            dispatch({
                              type: POST_LOGIN,
                              payload: {
                                ...loginData,
                                clientData: result.client,
                              },
                              role: role,
                              Privilages: Privilages,
                            });
                            navigate("/dashboard");
                            dispatch({
                              type: ACTIVETAB,
                              payload: "Dashboard",
                            });
                          },
                          () => {}
                        )
                      );
                    })
                  );
                } else {
                  let selectedPlanData = plans.find((p) => p.name === selectedPlan);
                  let price = selectedPlanData ? selectedPlanData[billingCycle] * 100 : 0;
                  console.log({
                    amount: price,
                    type: selectedPlan,
                    cycle: billingCycle,
                    priceId:
                      billingCycle == "yearly" ? selectedPlanData?.priceidYearly : selectedPlanData?.priceidMonthly,
                  });
                  navigate("/subscription-requests/payment", {
                    state: {
                      amount: price,
                      type: selectedPlan,
                      cycle: billingCycle,
                      priceId:
                        billingCycle == "Yearly" ? selectedPlanData?.priceidYearly : selectedPlanData?.priceidMonthly,
                    },
                  });
                }
              }}
            />
          )}
          {/* <AuthButton
          className="px-4 py-2 text-white rounded-md"
          width={'20%'}
          title={selectedPlan === 'Free Forever' ? 'Get Started' : 'Pay Now'}
          onClick={() => {
            if (selectedPlan === 'Free Forever') {
              dispatch(afterPayment({
                amount: 0,
                currency: "USD",
                description: '',
                paymentId: '',
                paymentStatus: "paid",
                paymentDate: Date.now(),
                subscriptiontype: 'Free Forever'
              }, loginData?.accessToken, () => {
                dispatch(getClientbyid(loginData?.accessToken, loginData?.clientData?.id, (result) => {
                  dispatch({
                    type: POST_LOGIN,
                    payload: { ...loginData, clientData: result.client },
                    role: role,
                        Privilages:Privilages

                  })
                  navigate('/dashboard')
                  dispatch({
                    type: ACTIVETAB,
                    payload: 'Dashboard',
                  });

                }))
              }))
            }
            else {
              let price = selectedPlan === 'Free Forever' ? 4.99 * 100 : selectedPlan === "Repotal Pro" ? 14.99 * 100 : 30.99 * 100;
              navigate('/subscription-requests/payment', {
                state: { amount: price, type: selectedPlan },
              });
            }
          }}
        /> */}
        </div>
      )}
    </div>
  );
};

export default PlanSubscription;
